<!-- =========================================================================================
  File Name: DataListListView.vue
  Description: Data List - List View
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="photo-list-view" class="photoContainer" style="max-width: 1320px;">
    
    <div class="flex flex-wrap flex-grow" style="min-height: 60px; justify-content: space-between;">
      <feather-icon class="sm:inline-flex xl:hidden cursor-pointer" icon="MenuIcon" style="height: 20px; margin-right: 10px;" @click.stop="showSidebar"></feather-icon>
      <!-- <div class="flex flex-wrap items-center flex-grow photo-list-header"> -->
        <div style="margin: 0 30px">  
          <!-- <vs-button :disabled="editPhotoCheck.length == 0" class="p-2" style="margin: 0px 50px;" type="border" color="primary" @click="sendToPhotoBank(editPhotoCheck)">포토뱅크전송</vs-button> -->
          <!-- <vs-button :disabled="editPhotoCheck.length == 0" class="p-2" style="margin: 0px 2px;" type="border" color="success" @click="writeNews(editPhotoCheck)">기사작성</vs-button>
          <vs-button :disabled="editPhotoCheck.length == 0" class="p-2" style="margin: 0px 2px;" type="border" color="primary" @click="editPhoto(editPhotoCheck)">포토수정</vs-button>
          <vs-button :disabled="editPhotoCheck.length == 0" class="p-2" style="margin: 0px 2px;" type="border" color="danger" @click="deletePhoto(editPhotoCheck)">포토삭제</vs-button> -->
        </div>
        <div class="flex">
          <v-select style="width: 140px; margin-right: 10px;" placeholder="직접입력" label="name" :reduce="e => e.code" @input="setDate"
            :options="dateRanges"/>
          <datepicker type="date" range v-model="dateRange2" lang="kr" style="width: 200px; margin-right: 10px;" />
          <!-- <date-range-picker 
            v-model="dateRange" 
            :locale-data="locale"
            :opens="opens"
            :ranges="ranges"    
          >
            <div id="dates" slot="range" ></div>
          </date-range-picker> -->
          <v-select style="width: 100px; margin-right: 10px;" placeholder="기자" label="nickname" :reduce="nickname => nickname.idx" v-model="selectedWriter"
            :options="writer"/>
        <!-- <vs-select
          placeholder="기자 선택"
          label=""
          v-model="selectedWriter"
          width="110px"
          >
          <vs-select-item :key="index" :value="item.idx" :text="item.nickname" v-for="(item,index) in writer"/>
        </vs-select> -->
        <!-- <vs-select
          placeholder="기사 상태 선택"
          label=""
          v-model="state"
          width="100px"
          >
          <vs-select-item :key="index" :value="item.code" :text="item.name" v-for="(item,index) in states"/>
        </vs-select> -->
          <!-- <v-select style="width: 100px" placeholder="카테고리" label="name" :reduce="name => name.code" v-model="category1"
            :options="categories1"/> -->
        <!-- <vs-select
          placeholder="카테고리 선택"
          label=""
          v-model="category1"
          width="100px"
          >
          <vs-select-item :key="index" :value="item.code" :text="item.name" v-for="(item,index) in categories1"/>
        </vs-select> -->
          <!-- <v-select style="width: 100px" placeholder="사용여부" label="name" :reduce="name => name.code" v-model="usedOption"
            :options="usedOptionList" :clearable="false"/>       -->
          <div style="padding-top: 0;">
            <vs-input style="width: 200px; margin-right: 10px;" class="inputx" placeholder="포토 검색" v-model="searchText" @keyup.enter="searchPhotoList(searchVar)"/>
          </div>
          <div><vs-button color="primary" type="border" class="p-2 cursor-pointer" @click="searchPhotoList(searchVar)">검색</vs-button></div>
        <!-- ITEMS PER PAGE -->
        <!-- <div  id="data-list-search-rank" style="padding-top: 0;">
          <div class="p-2 border border-solid border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
            <span class="mr-2">{{ ((currentx - 1) * searchVar.itemsPerPage) + 1 }} - {{ numOfPhoto >= searchVar.itemsPerPage ? (currentx * searchVar.itemsPerPage) : numOfPhoto }} of {{ numOfPhoto }}</span>
            
        <vs-dropdown>
          <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            <vs-dropdown-menu>
              <vs-dropdown-item @click="itemsPerPage=15">
                <span>15</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage=20">
                <span>20</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage=30">
                <span>30</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage=50">
                <span>50</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
            </div>
        </div> -->
      <!-- </div> -->
      </div>
    </div>
    <div class="flex flex-wrap flex-grow">
      <div class="photo-list" :data="photo" :key="index" v-for="(photo, index) in users">
        <img :src="imagePath(photo.mimg)" style="max-width: 250px; height: 150px; cursor:pointer;" @click="photoView(imagePath(photo.mimg)) "/>
        <!-- <ckeditor class="photo-subject" :editor="editor" v-model="photo.subject" :config="editorConfig"></ckeditor> -->
        <vs-textarea v-model="photo.subject" rows="2" />
        <!-- <textarea v-model="photo.subject" name="subject" style="width:244px;color:#000f75;font-size:12px;font-weight:bold" rows="2" /> -->
        등록일: {{photo.reg_date}}
        <!-- <ckeditor class="photo-contents" :editor="editor" v-model="photo.contents" :config="editorConfig"></ckeditor> -->
        <vs-textarea v-model="photo.contents" rows="5" />
        <!-- <textarea v-model="photo.contents" name="contents" style="width:244px;font-size:12px;" rows="5" /> -->
        <vs-button v-if="photo.newsidx > 0" style="padding: 0.5rem; margin: 0px 2px;" size="small" color="warning" @click="editNews(photo.newsidx)">기사수정</vs-button>
        <!-- <vs-checkbox v-model="editPhotoCheck" :vs-value="photo" style="align: center"/> -->
      </div>
    </div>
    <div style="width: 450px; margin: 0 auto;">
        <vs-pagination :total="numOfPages" v-model="currentx"></vs-pagination>
    </div>
    <!-- <div style="text-align: center;">
      <feather-icon icon="ChevronLeftIcon" style="margin-right: 10px;" @click="pagenation('back')"/>
      <span style="font-size: 20px; vertical-align: top; line-height: 25px; margin-right: 10px;">{{currentx}}</span>
      <feather-icon icon="ChevronRightIcon" style="margin-right: 10px;" @click="pagenation('next')"/>
    </div> -->


    <!-- Start: 포토 팝업 -->
    <div class="photo-fullsize">
      <vs-popup ref="popup-photo" classContent="popup-photo" title="" :active.sync="photoModalActive">
        <img :src="photoModalImg" style="max-width:600px"/>
      </vs-popup>
    </div>
    <!-- End: 포토 팝업 -->


  </div>
</template>

<script>
// import classicEditor from '@ckeditor/ckeditor5-build-classic';
import vSelect from 'vue-select'
import { imageUrl } from '@/utils/imageUrl'
// import AddNewDataSidebar from '../AddNewDataSidebar.vue';
import DateRangePicker from 'vue2-daterange-picker';
//you need to import the CSS manually (in case you want to override it)
import 'vue2-daterange-picker/dist/lib/vue-daterange-picker.min.css';
import moment from 'moment';

export default {
  components: {
    'v-select': vSelect,
    // AddNewDataSidebar
    DateRangePicker,
  },
  data() {
    return {
      // editor: classicEditor,
      editorConfig: {
        toolbar: {
            items: [],
        }
      },
      selectedIndex: 0,
      selectedId: 0,
      users: [],//[{contents: '', subject: '', writer: '', mimg: ''}],
      currentx: 1,
      numOfPhoto: 0,
      numOfPages: 0,
      searchVar: {
        startRow: 0,
        itemsPerPage: 20,
        state: null,
        usedOption: 'article',
        writer: null,
        searchText: '',
        startDate: moment().subtract(1, 'year'),
        endDate: moment(),
      },
      editPhotoCheck: [],
      photoModalActive: false,
      photoModalImg: '',
      itemsPerPage: 15,
      state: null,
      selectedWriter: null,
      usedOption: 'article',
      searchText: '',
      usedOptionList: [
        {code: 'article', name: '기사사진'},
      ],
      dateRange: { // used for v-model prop
          startDate: moment().subtract(1, 'year'),
          endDate: moment().add(7, 'day'),
      },
      dateRange2: [new Date(moment().subtract(1, 'year')), new Date()],
      writer: [],
      states: [],
      categories1: [],
      dateRanges: [
        {code: '1 year', name: '1년'},
        {code: '1 week', name: '1주'},
        {code: '1 month', name: '1개월'},
        {code: '3 month', name: '3개월'},
      ],
      ranges: { //default value for ranges object (if you set this to false ranges will no be rendered)
          '오늘': [moment(), moment()],
          '1주일': [moment().subtract(1, 'week'), moment()],
          '한달': [moment().subtract(1, 'month'), moment()],
          '이번 달': [moment().startOf('month'), moment().endOf('month')],
          '지난 달': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
      },
      opens: "center",//which way the picker opens, default "center", can be "left"/"right"
      locale: {
          direction: 'ltr', //direction of text
          format: 'YYYY-MM-DD', //fomart of the dates displayed
          separator: ' - ', //separator between the two ranges
          applyLabel: '선택',
          cancelLabel: '취소',
          weekLabel: 'W',
          customRangeLabel: 'Custom Range',
          "daysOfWeek": [
              "일",
              "월",
              "화",
              "수",
              "목",
              "금",
              "토"
          ],
          "monthNames": [
              "1월",
              "2월",
              "3월",
              "4월",
              "5월",
              "6월",
              "7월",
              "8월",
              "9월",
              "10월",
              "11월",
              "12월"
          ],
          firstDay: 0, //ISO first day of week - see moment documenations for details
          showISOWeekNumbers: true //show week numbers on each row of the calendar
      },
    }
  },
  beforeRouteLeave (to, from, next) {
    this.photoModalActive = false;
    setTimeout(() => { next(); }, 100);
},
  watch: {
    currentx: function() {
                                    // currentx-1 is value before changed by watch: -> currentx:
      this.searchVar.startRow = (this.currentx-1) * this.searchVar.itemsPerPage;
      window.scrollTo(0,0);
      this.getPhotoList(this.searchVar);
    },
    itemsPerPage: function() {
      this.searchVar.itemsPerPage = this.itemsPerPage;
      this.searchVar.startRow = 0;
      window.scrollTo(0,0);
      this.getPhotoList(this.searchVar);
    }
  },
  computed: {
    currentPage() {
      if(this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
    // PROFILE
    activeUserInfo() {
        return this.$store.state.AppActiveUser;
    },
  },
  methods: {
    setDate(event){
      // console.log(event)
      if(typeof event == 'string'){
        let data = event.split(' ');
        if(data[0] && data[1]){
          this.dateRange2 = [new Date(moment().subtract(data[0], data[1])), new Date()]
        }
      }
    },
    pagenation(data){
      if(data == 'back'){
        if(this.currentx > 1){ this.currentx -= 1 }
      }
      else if(data == 'next'){
        this.currentx += 1;
      }
    },
    imagePath(img){
      // 옛 CDN(cdn.jasm.co.kr) 하드코딩 + photo/ 누락으로 전부 깨져 있었다.
      // 규칙은 utils/imageUrl 한 곳에 모아 뒀다.
      return imageUrl(img);
    },
    photoView(imageSrc){
      console.log('in photoView')
      this.photoModalImg = imageSrc;
      this.photoModalActive = true;
    },
    // 포토뱅크전송·포토수정·포토삭제는 2026-09-06 에 걷어냈다(버튼은 이미 주석 상태였다).
    // 서버의 /api/photo/sendPhotoBank · editPhoto · deletePhoto 도 함께 삭제했다 —
    // 데일리안 `photo` 테이블을 쓰는데 중앙신문 DB 에 그 테이블이 없다.
    writeNews(data){
      var photoId = '';
      for(var i in data){
        photoId += data[i].pno + '|';
      }
      photoId = photoId.substring(0, photoId.length -1);
      console.log("write: ", photoId);
      this.$router.push({path: '/writeArticles', query: { pno: photoId, fromPhotoList: true}});
    },
    editNews(newsId){
      console.log("edit: ", newsId);
      this.$router.push({path: '/writeArticles', query: { id: newsId}});
    },
    searchPhotoList(data){
      data.startRow = 0;
      this.currentx = 1;
      // console.log(this.state)
      data.state = this.state;
      data.usedOption = this.usedOption;
      data.writer = this.selectedWriter;
      data.searchText = this.searchText;
      data.startDate = this.dateRange2[0];
      data.endDate = this.dateRange2[1];
      this.getPhotoList(data);
    },
    getPhotoList(data) {
      this.editPhotoCheck = []
      // console.log(data.state, data.category1, data.writer)
      this.$vs.loading({
        scale: 1.5
      });
      const thisIns = this;
      this.$http.post('/api/getNewsList/photo', data)
        .then(function (response) {
          console.log(response.data)
          if(response.data[0][0].photoCount){
            thisIns.numOfPhoto = response.data[0][0].photoCount;
            thisIns.numOfPages = Math.ceil(response.data[0][0].photoCount / thisIns.searchVar.itemsPerPage);
            thisIns.users = response.data[1];
          }else{
            thisIns.numOfPhoto = 0;
            thisIns.numOfPages = 0;
            thisIns.users = [];//[{contents: '', subject: '', writer: '', mimg: ''}];
          }
          // thisIns.users = response.data;
          thisIns.$vs.loading.close();          
        })
        .catch(function (error) {
          var errorText = error.toString();
          if(errorText.includes('401')){
            alert('로그인 해주세요!')
            thisIns.$router.push({path: '/pages/login?to='+ thisIns.$router.history.current.path, query: thisIns.$router.history.current.query})
          }
          thisIns.$vs.notify({
            title:'Error',
            text: error,
            color:'danger',
            iconPack: 'feather',
            icon:'icon-alert-circle'})
          thisIns.$vs.loading.close(); 
        });
    },
    showSidebar() {
        this.$store.commit('TOGGLE_IS_SIDEBAR_ACTIVE', true);
    },
  },
  created() {
    this.states = this.$store.state.states;
    this.writer = this.$store.state.writer;
    // console.log(this.$store.state.portals);
    this.getPhotoList(this.searchVar);
  },
  mounted() {
    this.isMounted = true;
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/custom-style/photoList.scss";
</style>
